import { render } from "./RowProgram.vue?vue&type=template&id=7538c930"
import script from "./RowProgram.ts?vue&type=script&lang=js"
export * from "./RowProgram.ts?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__